import { useState } from 'react';
import { compatApi } from '../../utils/Intercepter';
import { toast } from 'react-toastify';
import toastConfig from '../../const/toastConfig';
import { PURPLE, MINT } from '../../utils/designUtils';

export default function ResetPassword() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error('이메일을 입력해주세요.', toastConfig);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error('올바른 이메일 형식이 아닙니다.', toastConfig);
            return;
        }

        setIsLoading(true);
        try {
            const response = await compatApi.post('/auth/reset-password', { email });
            if (response.data.result) {
                toast.success('비밀번호 재설정 메일이 발송되었습니다.', toastConfig);
                setEmail('');
            } else {
                toast.error(response.data.message || '메일 발송에 실패했습니다.', toastConfig);
            }
        } catch (error) {
            console.error(error);
            toast.error('오류가 발생했습니다. 다시 시도해주세요.', toastConfig);
        } finally {
            setIsLoading(false);
        }
    };

    const label = { display: 'block', fontWeight: 600, marginBottom: 6, color: '#1f1d2e', fontSize: 14 };
    const inputStyle = {
        width: '100%', padding: '12px 14px', borderRadius: 10,
        border: '1.5px solid #e5e0f7', outline: 'none', fontSize: 14,
        color: '#1f1d2e', background: '#faf9fe', boxSizing: 'border-box', boxShadow: 'none'
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f4fa' }}>
            <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(124,107,217,0.10)', border: '1px solid rgba(124,107,217,0.12)', padding: '40px', width: '100%', maxWidth: 480 }}>
                <h2 style={{ textAlign: 'center', fontWeight: 700, marginBottom: 8, color: '#1f1d2e', fontSize: 22 }}>비밀번호 찾기</h2>
                <p style={{ textAlign: 'center', color: '#7a7889', fontSize: 14, marginBottom: 28 }}>
                    가입하신 이메일 주소를 입력하시면<br />비밀번호 재설정 링크를 보내드립니다.
                </p>
                <form onSubmit={handleSubmit} style={{ maxWidth: 'none', margin: 0, padding: 0, border: 'none', borderRadius: 0, background: 'none' }}>
                    <div style={{ marginBottom: 20 }}>
                        <label style={label}>이메일</label>
                        <input
                            type="email"
                            placeholder="example@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isLoading}
                            style={inputStyle}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={isLoading}
                        style={{
                            display: 'block', width: '100%', padding: '13px', borderRadius: 10,
                            background: `linear-gradient(135deg, ${PURPLE}, ${MINT})`, color: '#fff',
                            fontWeight: 700, fontSize: 15, border: 'none',
                            cursor: isLoading ? 'not-allowed' : 'pointer', marginBottom: 10,
                            opacity: isLoading ? 0.7 : 1
                        }}
                    >
                        {isLoading ? '전송 중...' : '비밀번호 재설정 메일 발송'}
                    </button>
                    <a
                        href="/"
                        style={{
                            display: 'block', width: '100%', padding: '12px', borderRadius: 10,
                            border: '1.5px solid #e5e0f7', color: PURPLE, fontWeight: 600,
                            fontSize: 14, textAlign: 'center', textDecoration: 'none', background: 'transparent'
                        }}
                    >
                        로그인으로 돌아가기
                    </a>
                </form>
            </div>
        </div>
    );
}
